'use strict';

class CreditorsController {
  /* @ngInject */
  constructor(CreditorsService, $scope, $q) {
    Object.assign(this, {
      CreditorsService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getCreditors();

    this.onPagination = () => {
      this.getCreditors();
    };
  }

  getCreditors() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    let queryReady = this.CreditorsService.getModels(qOpts).then(creditors => {
      this.creditors = creditors;
    });
    let countReady = this.CreditorsService.getCount(qOpts).then(result => {
      this.creditorsCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default CreditorsController;
